<script>
import { useAlert } from 'dashboard/composables';

export default {
  props: {
    inbox: {
      type: Object,
      required: true,
    },
  },
  emits: ['sync'],
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {},
  methods: {
    async updateTemplates() {
      try {
        this.isLoading = true;
        await this.$store.dispatch(
          'inboxes/syncWhatsappTemplates',
          this.inbox.id
        );
        useAlert(
          this.$t(
            'INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_SYNC_TEMPLATES.API_SUCCESS'
          )
        );
        this.$emit('sync');
      } catch (err) {
        useAlert(
          this.$t('INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_SYNC_TEMPLATES.API_ERROR')
        );
      }
      this.isLoading = false;
    },
  },
};
</script>

<template>
  <woot-button icon="repeat" :is-loading="isLoading" @click="updateTemplates">
    {{ $t('INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_SYNC_TEMPLATES.BUTTON') }}
  </woot-button>
</template>
